import React from "react";
import { Image } from "../../../components/Image/Image";
import { Recipe } from "@core/types";
import styles from "./recipe.module.scss";
import classNames from "classnames/bind";
import { useHistory } from "react-router";

const cx = classNames.bind(styles);

type RecipesViewListProps = {
  recipes: Recipe[];
};

const RecipesViewList = ({ recipes }: RecipesViewListProps) => {
  const history = useHistory();

  const handleOpenRecipe = (recipeId:Recipe["id"]) => {
    history.push(`/recipe/${recipeId}`);
  };

  

  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 mx-5 gap-3">
        {recipes?.map((recipe) => {
          return (
            <div key={recipe.id} onClick={() => handleOpenRecipe(recipe.id)} className="flex flex-col min-h-[255px] min-w-[165px] gap-1.5">
              <div className="">
                <Image src={recipe.image} className="min-h-[205px]  rounded-2xl" />
              </div>
              <div className={cx("recipeTitle, px-1.5 line-clamp-2")}>{recipe.title}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecipesViewList;
